import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, themeLight, radius, breakpoints } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { ExpandMore } from '@styled-icons/material/ExpandMore';
import { propValidationConfig } from '../../propValidationConfig';
export const Dropdown = ({
  countries,
  preferredCountries,
  handleSelect,
  selected,
  width,
  disabled
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const onSelect = country => {
    handleSelect(country);
    setOpen(false);
  };
  const handleClickOutside = e => {
    if (!!dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };
  const handleEscape = useCallback(e => {
    if (e.key === 'Escape') {
      setOpen(false);
    }
  }, []);
  useEffect(() => {
    window.addEventListener('keydown', e => handleEscape(e));
    return () => {
      window.removeEventListener('keydown', e => handleEscape(e));
    };
  }, [handleEscape]);
  useEffect(() => {
    window.addEventListener('mousedown', e => handleClickOutside(e));
    return () => {
      window.removeEventListener('mousedown', e => handleClickOutside(e));
    };
  }, []);
  return /*#__PURE__*/React.createElement(Container, {
    ref: dropdownRef,
    "aria-expanded": open,
    "aria-haspopup": "listbox"
  }, /*#__PURE__*/React.createElement(ButtonWrap, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setOpen(!open),
    open: open,
    type: "button",
    disabled: disabled
  }, '+' + selected.code, " ", /*#__PURE__*/React.createElement(ExpandMore, {
    size: 24
  }))), open && countries && /*#__PURE__*/React.createElement(ListContainer, {
    width: width
  }, preferredCountries ? /*#__PURE__*/React.createElement(UL, null, preferredCountries.map(country => /*#__PURE__*/React.createElement(TopLi, {
    key: country.code
  }, /*#__PURE__*/React.createElement(Option, {
    onClick: () => onSelect(country),
    selected: selected && selected.code === country.code
  }, country.name)))) : null, /*#__PURE__*/React.createElement(UL, null, countries.map(country => /*#__PURE__*/React.createElement(BottomLi, {
    key: country.code
  }, /*#__PURE__*/React.createElement(Option, {
    onClick: () => onSelect(country),
    selected: selected && selected.code === country.code
  }, country.name))))));
};
export default Dropdown;
const Container = styled.div.withConfig({
  displayName: "dropdown__Container",
  componentId: "sc-154etho-0"
})(["position:relative;display:inline-flex;flex-direction:column;height:100%;"]);
const ButtonWrap = styled.div.withConfig({
  displayName: "dropdown__ButtonWrap",
  componentId: "sc-154etho-1"
})(["display:flex;height:100%;"]);
const Button = styled.button.withConfig(propValidationConfig).withConfig({
  displayName: "dropdown__Button",
  componentId: "sc-154etho-2"
})(["background:transparent;border:0;padding:0 0 0 ", ";display:flex;align-items:center;justify-content:center;box-sizing:border-box;cursor:pointer;&:after{content:'';border-right:1px solid;border-color:", ";height:calc(", " * ", ");margin-left:", ";}&:focus{outline:none !important;border:2px solid;margin:-1px;border-color:", " !important;border-radius:", " 0 0 ", " !important;padding-left:calc(", " - 1px);&:after{border:none;}}svg{margin-left:2px;}", ";@media (max-width:", "){", ";}", ""], spacing.space12, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, fontStyle.article.articleText['font-size'], fontStyle.article.articleText['line-height'], spacing.space4, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, radius.s, radius.s, spacing.space12, ({
  open
}) => open && css(["svg{transform:scaleY(-1);}"]), breakpoints.s, fontStyle.bodyText.small, ({
  disabled
}) => disabled && css(["color:", ";cursor:not-allowed;"], ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText));
const ListContainer = styled.div.withConfig({
  displayName: "dropdown__ListContainer",
  componentId: "sc-154etho-3"
})(["position:absolute;top:", ";margin-top:", ";left:0;box-shadow:0 2px 12px rgba(0,0,0,0.24);border-radius:", ";overflow-y:auto;z-index:99;width:", "px;max-height:calc(", " * 5.5);background:", ";::-webkit-scrollbar{width:", ";}::-webkit-scrollbar-thumb{border:", " solid transparent;background-clip:padding-box;border-radius:", ";background-color:#e8e8e8;}"], spacing.space48, spacing.space8, radius.s, props => props.width, spacing.space48, ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, spacing.space16, spacing.space4, spacing.space8);
const UL = styled.ul.withConfig({
  displayName: "dropdown__UL",
  componentId: "sc-154etho-4"
})(["padding:0;list-style:none;margin:0;"]);
const TopLi = styled.li.withConfig({
  displayName: "dropdown__TopLi",
  componentId: "sc-154etho-5"
})(["padding:0;list-style:none;&:last-child{border-bottom:1px solid rgba(0,0,0,0.12);}"]);
const BottomLi = styled.li.withConfig({
  displayName: "dropdown__BottomLi",
  componentId: "sc-154etho-6"
})(["padding:0;list-style:none;"]);
const Option = styled.button.withConfig(propValidationConfig).withConfig({
  displayName: "dropdown__Option",
  componentId: "sc-154etho-7"
})(["width:100%;text-align:start;white-space:nowrap;border:0;padding:0 ", ";box-sizing:border-box;appearance:none;height:", ";background:transparent;", ";&:hover{cursor:pointer;}&:hover,&:focus{background:", ";}"], spacing.space12, spacing.space48, fontStyle.bodyText.bodyText, nafColor.signature.yellow10);
//# sourceMappingURL=dropdown.js.map